document.addEventListener('DOMContentLoaded', (event) => {
    // list of invalid domains
    const invalidDomains = [
        'gmail.com',
        'yahoo.com',
        'hotmail.com',
        'aol.com',
        'msn.com',
        'yandex.ru',
        'mail.ru',
    ];

    // get the submit button
    const submitBtn = document.querySelector('#submit');
    const honeypot = document.querySelector('#email-hidden');
    // on submit button click
    submitBtn.addEventListener('click', () => {
        // get the email field
        const email = document.querySelector('#email');
        // split email at '@' character to get domain
        const domainPart = email.value.split('@')[1];

        // if the domain exists in the invalidDomains array
        if (invalidDomains.indexOf(domainPart) !== -1) {
            // clear email field
            email.value = '';
            // add a 'use business mail' placeholder
            email.setAttribute('placeholder', 'Please enter a business email');
            // prevent form submission
            return false;
        } else {
            // else if email is not invalid
            // submit form
            return true;
        }
    });
    //Honeypot anti-spam

    honeypot.oninput = function () {
        if (honeypot.value.length > 0) {
            submitBtn.remove();
            window.location.reload();
        }
    };
});
